var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [[_c("el-table", {
    ref: "table",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      border: "",
      "header-cell-style": {
        background: "#eef1f6",
        color: "#606266"
      }
    }
  }, [_c("el-table-column", {
    attrs: {
      height: "150",
      label: "服务器ID"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("p", [_vm._v(_vm._s(scope.row.serverId))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      height: "150",
      label: "服务器信息"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("p", [_vm._v(_vm._s(_vm.serverList[scope.row.serverId]))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      height: "150",
      label: "角色信息"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("a", {
          staticStyle: {
            cursor: "pointer",
            color: "#409EFF"
          },
          on: {
            click: function click($event) {
              return _vm.goRouterMsg(scope.row.roleId);
            }
          }
        }, [_vm._v("角色id：" + _vm._s(scope.row.roleId))]), _c("p", [_vm._v("角色名称：" + _vm._s(scope.row.roleName))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      height: "150",
      label: "时间",
      prop: "logTime"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "位置"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.positionName) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      height: "150",
      label: "玩法类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.gameplayTypeName) + " ")];
      }
    }])
  })], 1), _c("el-pagination", {
    style: {
      float: "right",
      padding: "20px"
    },
    attrs: {
      "current-page": _vm.page,
      "page-size": _vm.pageSize,
      "page-sizes": [5, 30, 50, 100, 500],
      total: _vm.total,
      layout: "total, sizes, prev, pager, next, jumper"
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })]], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };